import { LinkButton, Theme, useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { PROMO_LINK } from 'shared/constants/smb/links';
import clsx from 'clsx';

export const FirstTimeBanner: React.FC = () => {
  const device = useDeviceType();

  const btnSize = device === 'phone' ? 'M' : 'L';

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['text-block']}>
        <div className={styles['title']}>Впервые на Циан?</div>
        <div className={styles['description']}>Дарим 1 000 бонусов новым пользователям</div>
      </div>
      <div className={styles['btn']}>
        <Theme theme="colored">
          <LinkButton href={PROMO_LINK} target="_blank" rel="noopener noreferrer" fullWidth size={btnSize}>
            Разместить объявление
          </LinkButton>
        </Theme>
      </div>
    </div>
  );
};
